module.exports = __webpack_public_path__ + "img/cn.d14addf0.svg";